module.exports = __webpack_public_path__ + "static/media/tutorials.ae2d5c87.webp";